import { useState, useEffect } from "react";
import { useAuth } from "../../../../../../../auth/context";
import { useApi } from "../../../../../../../utils/hooks";
import { prefetchVademecum, vademecumVariantFor } from "./vademecumPrefetch";

export default function useVademecum() {
  const { user } = useAuth();
  const api = useApi();
  const [data, setData] = useState([]);

  useEffect(() => {
    let cancelled = false;
    // Calling prefetchVademecum here (not just reading the cached promise)
    // means every time this mounts -- e.g. the user comes back to the
    // medicine step after a previous attempt failed -- it automatically
    // retries, with no need for the user to do anything.
    const p = prefetchVademecum(api, vademecumVariantFor(user));
    p.then((result) => { if (!cancelled) setData(result); });
    return () => { cancelled = true; };
  }, []);

  return data;
}
